// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"9da09367","355":"ebc522d7","447":"76e4536a","486":"c4543c75","596":"37b76848","977":"bd633fd6"}[chunkId] + ".chunk.js";
};